if($('body').find('#price_slider').length){
  if($("#min-val").val() == ''){
    var min = parseInt($("#min-val").attr('min'));
  }else{
    var min = parseFloat($("#min-val").val());
  }
  if($("#max-val").val() == ''){         
    var max = parseFloat($("#max-val").attr('max'));
  }else{
    var max = parseFloat($("#max-val").val());
  }
  var def_min = parseInt($('#min-val').attr('min'));
  var def_max = parseFloat($("#max-val").attr('max'));
  function RangeSlider(min,max,def_min,def_max){
    var slider = document.getElementById('price_slider');
    noUiSlider.create(slider,{
        start: [min, max],
        connect: true,
        range: {
            'min': def_min,
            'max': def_max
        }
    });
    
    var snapValues = [
        document.getElementById('min-val'),
        document.getElementById('max-val')
    ];
    slider.noUiSlider.on('update', function (values,handle) {
        snapValues[handle].value = values[handle];
        if(handle===0 && def_min=== parseFloat(values[0])){
          snapValues[0].value ='';
        }else if(handle===1 && def_max=== parseFloat(values[1])){
          snapValues[1].value ='';
        }
    });  
    slider.noUiSlider.on('change', function (values, handle) {
        triggerChangeEvent(snapValues[handle]);
    });
    function triggerChangeEvent(element) {
        var event = new Event('change', { bubbles: true });
        element.dispatchEvent(event);
    }
    snapValues[0].addEventListener('change', function() {
        var val = parseFloat(this.value);
        if (!isNaN(val)) slider.noUiSlider.set([val, null]);
    });
    snapValues[1].addEventListener('change', function() {
        var val = parseFloat(this.value);
        if (!isNaN(val)) slider.noUiSlider.set([null, val]);
    });
  }
  
  RangeSlider(min,max,def_min,def_max);
  
 
}    